export const sortAlgToNumber = (sortMehtod: string) => {
  switch (sortMehtod) {
    case 'popularity':
      return 1;
    case 'new':
      return 2;
    case 'default':
      return 6;
    default:
      return 6;
  }
};

export const numberToSortAlg = (sort: number) => {
  switch (sort) {
    case 1:
      return 'popularity';
    case 2:
      return 'new';
    case 6:
      return 'default';
    default:
      return 'default';
  }
};
